import React, { CSSProperties } from 'react'

interface SupademoProps {
  showcaseId: string
  /** Aspect ratio as width/height. Default is 16/9. */
  aspectRatio?: number
}

const Supademo: React.FC<SupademoProps> = ({
  aspectRatio = 16 / 9,
  showcaseId,
}) => {
  // padding-bottom is percentage of width, so height = (1 / aspectRatio) * 100%
  const paddingBottom = `${100 / aspectRatio}%`

  const containerStyle: CSSProperties = {
    paddingBottom,
    position: 'relative',
    width: '100%',
  }

  const iframeStyle: CSSProperties = {
    border: 'none',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  }

  return (
    <div className=''>
      <div className='text-center d-none fw-semibold d-safari-block fs-fluid-22-32'>
        For the best experience, please view this demo in full screen.
      </div>
      <div
        className='rounded-xl mt-8 d-none d-md-block shadow overflow-hidden'
        style={containerStyle}
      >
        <iframe
          src={`https://app.supademo.com/showcase/${showcaseId}?embed=true`}
          style={iframeStyle}
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default Supademo
